import { render, staticRenderFns } from "./pamongPrestasi.vue?vue&type=template&id=6ba52b5d&scoped=true&"
import script from "./pamongPrestasi.vue?vue&type=script&lang=js&"
export * from "./pamongPrestasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba52b5d",
  null
  
)

export default component.exports